import { render, staticRenderFns } from "./AddAttachmentModal.vue?vue&type=template&id=f4d94faa&scoped=true"
import script from "./AddAttachmentModal.vue?vue&type=script&lang=js"
export * from "./AddAttachmentModal.vue?vue&type=script&lang=js"
import style0 from "./AddAttachmentModal.vue?vue&type=style&index=0&id=f4d94faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d94faa",
  null
  
)

export default component.exports